// extracted by mini-css-extract-plugin
export default {"modulesChipContainer":"ModulesSection__modulesChipContainer___f9GFc","modulesSelectionContainer":"ModulesSection__modulesSelectionContainer___aUKQd"};